import React, { useState, useEffect, useRef } from "react";
import { Modal, Row, Col, Image } from "antd";
import "./Gallery.css";
import SEO from "../SEO/SEO";

import Image1  from "./images/image1.jpeg";
import Image2  from "./images/image2.jpeg";
import Image4  from "./images/image4.jpeg";
import Image5  from "./images/image5.jpeg";
import Image6  from "./images/image6.jpeg";
import Image7  from "./images/image7.jpeg";
import Image8  from "./images/image8.jpeg";
import Image9  from "./images/image9.jpeg";
import Image10 from "./images/image10.jpeg";
import Image11 from "./images/image11.jpeg";
import Image13 from "./images/image13.jpeg";
import Image14 from "./images/image14.jpeg";
import Image16 from "./images/image16.jpeg";
import Image17 from "./images/image17.jpeg";
import Image18 from "./images/image18.jpeg";
import Image19 from "./images/image19.jpeg";
import Image20 from "./images/image20.jpeg";
import Image21 from "./images/image21.jpeg";
import Image22 from "./images/image22.jpeg";
import Image23 from "./images/image23.jpeg";
import Image24 from "./images/image24.jpeg";
import Image25 from "./images/image25.jpeg";
import Image26 from "./images/image26.jpeg";
import Image27 from "./images/image27.jpeg";
import Image28 from "./images/image28.jpeg";
import Image29 from "./images/image29.jpeg";
import Image30 from "./images/image30.jpg";

const images = [
  Image1, Image2, Image4, Image5, Image6, Image7, Image8, Image9, Image10,
  Image11, Image13, Image14, Image16, Image17, Image18, Image19, Image20,
  Image21, Image22, Image23, Image24, Image25, Image26, Image27, Image28,
  Image29, Image30,
];

/* Split title text into individual letter spans for animation */
const SplitText = ({ text, className, delay = 0 }) => {
  return (
    <span className={className}>
      {text.split("").map((char, i) => (
        <span
          key={i}
          className="gallery-letter"
          style={{ animationDelay: `${delay + i * 0.04}s` }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </span>
  );
};

const Gallery = () => {
  const [isModalOpen, setIsModalOpen]   = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [headerVisible, setHeaderVisible] = useState(false);
  const headerRef = useRef(null);

  /* Trigger header entrance animation on mount */
  useEffect(() => {
    const timer = setTimeout(() => setHeaderVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const openModal  = (src) => { setCurrentImage(src); setIsModalOpen(true); };
  const closeModal = ()    => { setIsModalOpen(false); setCurrentImage(null); };

  return (
    <div className="gallery-container">
      <SEO path="/gallery" />
      {/* ── HEADER ── */}
      <div
        className={`gallery-header ${headerVisible ? "gallery-header--visible" : ""}`}
        ref={headerRef}
      >
        {/* Floating particle dots */}
        <div className="gallery-particles">
          {[...Array(6)].map((_, i) => (
            <span key={i} className={`gallery-particle gallery-particle--${i + 1}`} />
          ))}
        </div>

        {/* Tag */}
        <div className={`gallery-tag ${headerVisible ? "gallery-tag--visible" : ""}`}>
          ✦ Our Portfolio
        </div>

        {/* Title — letter by letter animation */}
        <h1 className="gallery-title">
          <SplitText
            text="Every Frame, a "
            className="gallery-title__plain"
            delay={0.2}
          />
          <em className="gallery-title__em">
            <SplitText
              text="Masterpiece"
              className="gallery-title__gold"
              delay={0.9}
            />
          </em>
        </h1>

        {/* Subtitle — word by word fade */}
        <p className={`gallery-subtitle ${headerVisible ? "gallery-subtitle--visible" : ""}`}>
          A visual journey through our finest creations — each garden a living
          testament to craft, passion, and the art of outdoor living.
        </p>

        {/* Animated divider */}
        <span className={`gallery-divider ${headerVisible ? "gallery-divider--visible" : ""}`} />
      </div>

      {/* ── GRID ── */}
      <div className="gallery-grid-wrapper">
        <Row gutter={[10, 10]} justify="center">
          {images.map((src, i) => (
            <Col key={i} xs={12} sm={8} md={6} lg={4}>
              <div className="gallery-item" onClick={() => openModal(src)}>
                <Image
                  src={src}
                  alt={`Garden Project ${i + 1}`}
                  preview={false}
                  className="gallery-image"
                />
                {/* Corner bracket lines */}
                <span className="gallery-item__corner gallery-item__corner--tl" />
                <span className="gallery-item__corner gallery-item__corner--tr" />
                <span className="gallery-item__corner gallery-item__corner--bl" />
                <span className="gallery-item__corner gallery-item__corner--br" />
                {/* Bottom label */}
                <div className="gallery-item__icon">View</div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* ── FOOTER STRIP ── */}
      <div className="gallery-footer">
        <p>✦ Each project is uniquely designed — no two gardens are ever the same ✦</p>
      </div>

      {/* ── MODAL ── */}
      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={closeModal}
        centered
        width="auto"
        mask={true}
        styles={{
          mask: {
            background: "rgba(5,10,5,0.9)",
            backdropFilter: "blur(12px)",
          },
          content: {
            background: "transparent",
            boxShadow: "none",
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          },
          body: { padding: 0, margin: 0 },
        }}
        className="gallery-modal"
      >
        {currentImage && (
          <img
            src={currentImage}
            alt="Gallery Preview"
            className="modal-image"
            onClick={closeModal}
          />
        )}
      </Modal>
    </div>
  );
};

export default Gallery;